<template>
  <footer class="container-fluid">
    <div class="row" style="border-bottom: 1px solid #9c6939;"> 
        <div class="col-12" style="display: flex; justify-content: space-between;">
            <div style="width: 100%;">
                <p style="font-size: 25px; font-weight: bold; margin-bottom: 5px;" class="dark-gold">
                Thank you for your business
                </p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="dark-gold text-right"><strong>Good character.</strong></div>
            <div class="main-color-blue text-right"><strong>Easy capital.</strong></div>
        </div>
    </div>
  </footer>
</template>

<script>
export default {

}
</script>
